import { apiRequest } from "./client";

export const customersApi = {
  list(projectId, params = {}) {
    return apiRequest(`/projects/${projectId}/customers`, { params });
  },

  get(projectId, customerId) {
    return apiRequest(`/projects/${projectId}/customers/${customerId}`);
  },

  priceLists(projectId) {
    return apiRequest(`/projects/${projectId}/customers/price-lists`);
  },

  assignPriceList(projectId, customerId, priceListId, expectedUpdatedAt) {
    return apiRequest(`/projects/${projectId}/customers/${customerId}/price-list`, {
      method: "PATCH",
      body: JSON.stringify({ priceListId, expectedUpdatedAt }),
    });
  },

  updateStatus(projectId, customerId, status, reason, expectedUpdatedAt) {
    return apiRequest(`/projects/${projectId}/customers/${customerId}/status`, {
      method: "PATCH",
      body: JSON.stringify({ status, reason, expectedUpdatedAt }),
    });
  },
};
